import { DeheadingQaQcDto } from "@gtpl/shared-models/production-management";
import { EntityRepository, Repository } from "typeorm";
import { LogIdRequest } from "../dto/log-id-request";
import { DeheadingQAQC } from "../entities/de-heading-qa-qc.entity";

@EntityRepository(DeheadingQAQC)
export class DeheadingQAQCRepository extends Repository<DeheadingQAQC> {

    async getSamplesInfoByLogId(req: LogIdRequest): Promise<DeheadingQAQC> {
        try {
            const logInfo = await this.createQueryBuilder('deheading_qa_qc')
                .leftJoinAndSelect('deheading_qa_qc.deheadingSampleInfo', 'deheadingSampleInfo')
                .where(`log_id='${req.productionLogid}'`)
                .getOne();
            return logInfo
        } catch (error) {
            return error
        }
    }


}